import React, { useEffect } from 'react';
import { useNavigate, useOutletContext } from 'react-router-dom';
import styled from 'styled-components';
import { useTheme } from '../../middleware/ThemeContext';
import ContactRolesListings from './ContactRolesListings';

const MainContent = styled.div<{ theme: any }>(({ theme }) => ({
    flexGrow: 1,
    backgroundColor: theme.colors.contentBackground,
    color: theme.colors.contentText,
    minWidth: '600px',
}));

type OutletContextType = {
    setSelectedEntity: (type: "roles", id: number) => void;
    setRefreshTrigger: React.Dispatch<React.SetStateAction<number>>;
    refreshTrigger: number;
    onEditRole: (id: number) => void;
};

const Roles = () => {

    const { theme } = useTheme();
        const navigate = useNavigate();
    
        const {
            setSelectedEntity,
            setRefreshTrigger,
            refreshTrigger,
            onEditRole,
        } = useOutletContext<OutletContextType>();

        // const { onEditRole } = useOutletContext<OutletContextType>();
    
        useEffect(() => {
            const token = JSON.parse(localStorage.getItem('authData') || '{}')?.accessToken;
            if (!token) navigate('/');
        }, [navigate]);

  return (
    <MainContent theme={theme}>
        <ContactRolesListings
            onEditRole={onEditRole}
            refreshTrigger={refreshTrigger}
        />
    </MainContent>
  )
}

export default Roles